import { signedNetAmount } from '../portal-usd-wallet/ledgerUtils';
export function usdSpentFromUsdRow(row) {
    return Math.abs(signedNetAmount(row));
}
export function buildUsdConversionSnapshot(usdRow, creditsMagnitude) {
    const usdSpent = usdSpentFromUsdRow(usdRow);
    if (!(usdSpent > 0) || !(creditsMagnitude > 0))
        return null;
    return {
        usdSpent,
        ratePerCredit: Number.parseFloat((usdSpent / creditsMagnitude).toFixed(4)),
    };
}
export function readEmbeddedUsdConversion(entry, creditsMagnitude) {
    var _a, _b;
    const spent = toNum((_a = entry.usdConversionSpent) !== null && _a !== void 0 ? _a : entry.usd_conversion_spent);
    if (spent == null || !(spent > 0))
        return null;
    const rateEmbedded = toNum((_b = entry.usdConversionRatePerCredit) !== null && _b !== void 0 ? _b : entry.usd_conversion_rate_per_credit);
    const ratePerCredit = rateEmbedded != null && rateEmbedded > 0
        ? rateEmbedded
        : creditsMagnitude > 0
            ? Number.parseFloat((spent / creditsMagnitude).toFixed(4))
            : 0;
    return { usdSpent: spent, ratePerCredit };
}
function toNum(v) {
    if (v === undefined || v === null || v === '')
        return null;
    const n = Number(v);
    return Number.isFinite(n) ? n : null;
}
export function createResolveUsdConversion(fetchUsdRow) {
    return async (usdLedgerId, creditsMagnitude) => {
        const row = await fetchUsdRow(usdLedgerId);
        if (!row)
            return null;
        return buildUsdConversionSnapshot(row, creditsMagnitude);
    };
}
